const List = () => import(/* webpackChunkName: "user" */ './List.vue')
const Add = () => import(/* webpackChunkName: "user" */ './Add.vue')
const Edit = () => import(/* webpackChunkName: "user" */ './Edit.vue')
const ResetPassword = () => import(/* webpackChunkName: "user" */ './ResetPassword.vue')

export default [
  {
    path: '',
    name: 'User',
    component: List
  },
  {
    path: 'list',
    name: 'UserList',
    component: List
  },
  {
    path: 'add',
    name: 'UserAdd',
    component: Add
  },
  {
    path: 'edit',
    name: 'UserEdit',
    component: Edit,
    props: true
  },
  {
    path: 'reset-password',
    name: 'UserResetPassword',
    component: ResetPassword,
    props: true
  }
]
